import { render, staticRenderFns } from "./AbsoluteDiscountTable.vue?vue&type=template&id=49623b2e&scoped=true"
import script from "./AbsoluteDiscountTable.vue?vue&type=script&lang=js"
export * from "./AbsoluteDiscountTable.vue?vue&type=script&lang=js"
import style0 from "./AbsoluteDiscountTable.vue?vue&type=style&index=0&id=49623b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49623b2e",
  null
  
)

export default component.exports